import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Standardized version of the job title. In other words, you may have many job titles that are effectively the same type.',
    name: 'Job Type',
    partialId: PartialId.Standard.create('job_type'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
